import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Flex, Stack } from "@chakra-ui/react";
import { getInventoryControlFilteredData } from "../services/inventoryControlServices";
import Input from "components/form/Input";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";

export default function FilterModal({ onClose, data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [filteredData, setFilteredData] = useState(data);

  // Filter Data
  const [filterCriteria, setFilterCriteria] = useState({
    Name: "",
    SKU: "",
    Branch: "",
  });

  const handleFilterInventoryControl = (e) => {
    e.preventDefault();

    const filteredResult = data.filter((item) => {
      const { Name, SKU, Branch } = filterCriteria;

      let filterName = true;
      let filterRef = true;
      let filterBranch = true;

      if (Name) {
        filterName = item?.ProductName?.toLowerCase().includes(
          Name.toLowerCase()
        );
      }

      if (SKU) {
        filterBranch = item?.Ref?.toLowerCase().includes(SKU?.toLowerCase());
      }

      if (Branch) {
        filterRef = item?.Branch?.toLowerCase().includes(Branch?.toLowerCase());
      }

      return filterName && filterRef && filterBranch;
    });

    setFilteredData(filteredResult);
    onClose();
    dispatch(getInventoryControlFilteredData(filteredResult));
  };

  return (
    <>
      <GModal
        onClose={onClose}
        modalHeader={t("pages.reports.business_reports.filter")}
        modalContent={
          <Box p={4}>
            <form onSubmit={handleFilterInventoryControl}>
              <Stack spacing={6}>
                <Input
                  label={t("pages.reports.reports_tables.name")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.name")}
                  name="Name"
                  value={filterCriteria.Name}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      Name: e.target.value,
                    })
                  }
                />

                <Input
                  label={t("pages.reports.reports_tables.reference")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.reference")}
                  name="SKU"
                  value={filterCriteria.SKU}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      SKU: e.target.value,
                    })
                  }
                />

                <Input
                  label={t("pages.reports.reports_tables.branch")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.branch")}
                  name="Branch"
                  value={filterCriteria.Branch}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      Branch: e.target.value,
                    })
                  }
                />

                <Flex gap={4}>
                  <GButton
                    type="submit"
                    title={t("general.save")}
                    bg="primary"
                    color="light"
                    border="1px solid transparent"
                    hover={{
                      color: "primary",
                      borderColor: "primary",
                      bg: "none",
                    }}
                  />
                  <GButton
                    title={t("general.close")}
                    onClick={onClose}
                    bg="red.600"
                    border="1px solid transparent"
                    color="light"
                    hover={{
                      color: "red.600",
                      borderColor: "red.600",
                      bg: "none",
                    }}
                  />
                </Flex>
              </Stack>
            </form>
          </Box>
        }
      />
    </>
  );
}
